/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SheetRowPredicateTypeFromJSON, SheetRowPredicateTypeToJSON, } from './';
export function SheetRowPredicateRepresentationFromJSON(json) {
    return SheetRowPredicateRepresentationFromJSONTyped(json, false);
}
export function SheetRowPredicateRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        type: SheetRowPredicateTypeFromJSON(json['type']),
        children: !exists(json, 'children') ? undefined : json['children'],
        dimensionTagId: !exists(json, 'dimensionTagId') ? undefined : json['dimensionTagId'],
        fromTableTagId: !exists(json, 'fromTableTagId') ? undefined : json['fromTableTagId'],
        toTableTagId: !exists(json, 'toTableTagId') ? undefined : json['toTableTagId'],
    };
}
export function SheetRowPredicateRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        type: SheetRowPredicateTypeToJSON(value.type),
        children: value.children,
        dimensionTagId: value.dimensionTagId,
        fromTableTagId: value.fromTableTagId,
        toTableTagId: value.toTableTagId,
    };
}
